module.exports = __webpack_public_path__ + "static/media/44-1.630b20db.mp3";